export default __webpack_public_path__ + "static/media/Dundas.c52d23b5.png";